// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2x8V1","header":"ReportDetails_header__18DrI","title":"ReportDetails_title__KGn3A","left":"ReportDetails_left__KT00g"};